import type { SiteSettings } from "@/mocks/adminData";

const DEFAULT_VALUES_IMAGE = "https://www.au2p0rz.vip/assets/values-pc-DmGeFkyC.webp";

interface ValuesSectionProps {
  settings: SiteSettings;
}

export default function ValuesSection({ settings }: ValuesSectionProps) {
  const valuesImage = settings.values_image || DEFAULT_VALUES_IMAGE;

  return (
    <section id="values" className="w-full bg-white">
      <div className="px-4 md:px-8 lg:px-10 pt-5 md:pt-8">
        <div className="max-w-6xl mx-auto flex items-center gap-2 mb-4">
          <span className="w-1 h-5 rounded-full bg-red-500 flex-shrink-0"></span>
          <h2 className="text-base md:text-lg font-bold text-gray-800">核心价值观</h2>
        </div>
      </div>
      <div className="w-full">
        <img
          src={valuesImage}
          alt="核心价值观"
          className="w-full block"
          style={{ display: "block" }}
          loading="lazy"
        />
      </div>
    </section>
  );
}